import { render, staticRenderFns } from "./Mapping.vue?vue&type=template&id=447a8db2&scoped=true&"
import script from "./Mapping.vue?vue&type=script&lang=js&"
export * from "./Mapping.vue?vue&type=script&lang=js&"
import style0 from "./Mapping.vue?vue&type=style&index=0&id=447a8db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a8db2",
  null
  
)

export default component.exports